import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'my_brands-insights_card-click';

/**
 * This is the Insights Card Click event.

These are the following params
1. Origin (i.e brand-page, my-brands-page, etc)
2. Item clicked (i.e brand name, product image)
3. token (brand token, product token)
 */
export function trackMyBrandsInsightsCardClick(
  customParameterToken: string,
  customParameterToken2: string,
  customParameterToken3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      customParameterToken,
      customParameterToken2,
      customParameterToken3,
    },
  });
}
